import { type KeyboardEvent, useCallback } from 'react';

import { logger } from '@zep/core-logger';

import {
  goToNextFocusable,
  goToPreviousFocusable,
} from '../../focus/focusChain';
import {
  isNextFocusKeyboardEvent,
  isPreviousFocusKeyboardEvent,
} from '../../focus/focusUtils';
import { useQuizList } from '../../useQuizList';
import { useQuizControl } from '../QuizControlProvider';

export const useSubjectiveAnswerHotKey = ({
  isLastAnswer,
  answerIndex,
}: {
  isLastAnswer: boolean;
  answerIndex: number;
}) => {
  const { index: quizIndex } = useQuizControl();
  const { quizList, handleCreate } = useQuizList();

  return useCallback(
    (event: KeyboardEvent) => {
      //새로운 퀴즈를 만들지를 먼저 결정
      if (
        quizList.length === quizIndex + 1 &&
        isLastAnswer &&
        (event.key === 'Enter' || event.key === 'Tab')
      ) {
        event.preventDefault();
        handleCreate('subjective');
        logger.track('add_quizItem', {
          type: 'subjective',
          position: 'shortcut_key',
        });
        return true;
      }

      if (isNextFocusKeyboardEvent(event)) {
        event.preventDefault();
        goToNextFocusable({
          current: `quizList.${quizIndex}.subjectiveData.answerList.${answerIndex}.text`,
        });
        return true;
      }

      if (isPreviousFocusKeyboardEvent(event)) {
        event.preventDefault();
        goToPreviousFocusable({
          current: `quizList.${quizIndex}.subjectiveData.answerList.${answerIndex}.text`,
        });
        return true;
      }
    },
    [answerIndex, isLastAnswer, quizIndex, quizList.length, handleCreate],
  );
};
